// const K = [10, 25, 45, 77];
// const A = -0.2;
// // var B = [9.19814356, 10.987186, 11.4973043, 12.05979376];
// const C = 0.12;

const K = [10, 25, 45, 77];
const A = -0.2;
// var B = [9.19814356, 10.987186, 11.4973043, 12.05979376];
const C = 0.12;
const STEP_HEIGHT_POWER = 4.5;
const STEP_WEIGHT_POWER = 7.0;

export const lbToKg = function(value) {
  return 0.4536*value;
}

export const kgToLb = function(value) {
  return value/0.4536;
}

export const inToCm = function(value) {
  return 2.54*value;
}

export const cmToIn = function(value) {
  return value*0.3937;
}

export const daysBetween = function(date1, date2) {
  return Math.floor(( Date.parse(date2) - Date.parse(date1) ) / 86400000);
}

// START - gompertz function
const mgompertz = function(step, w, b, d, step_power) {
  return Math.max(0, (w-A)*Math.exp(-Math.exp(-C*(Math.pow(step/step_power, d)-b))) + A);
}

const mgompertz_inv = function(step, y, d, w_init, step_power) {
  var w = w_init;
  var iterations = 100;
  // debugger
  for (let i = 0; i < iterations; i++) {
    w = (y-A)/Math.exp(-Math.exp(-C*(Math.pow(step/step_power, d(w))-b(w)))) + A;
  }
  return w;
}

const fgompertz = function(step, w, step_power) {
  return mgompertz(step, w, b(w), d(w), step_power);
}

const fgompertz_inv = function(step, y, step_power) {
  var w_init = 0;
  if (y < fgompertz(step, K[1], b(K[1]), d(K[1]), step_power)) {
    w_init = K[0];
  } else if (y < fgompertz(step, K[2], b(K[2]), d(K[2]), step_power)) {
    w_init = K[1];
  } else {
    w_init = K[2];
  }

  return mgompertz_inv(step, y, d, w_init, step_power);
}
// END - gompertz function

export const getAge = function(birthdate_el, measurement_el) {
  return daysBetween($(birthdate_el).val(), $(measurement_el).val());
}

export const getH = function(age, value) {
  return fgompertz_inv(parseFloat(age), parseFloat(value), STEP_HEIGHT_POWER);
}

export const getHCurve = function(steps, w) {
  let curve = [];
  for (let i = 0; i < steps.length; i += 1) {
    curve.push([steps[i], fgompertz(steps[i], w, STEP_HEIGHT_POWER)]);
  }
  return curve;
}

export const getW = function(age, value) {
  return fgompertz_inv(parseFloat(age), parseFloat(value), STEP_WEIGHT_POWER);
}

export const getWCurve = function(steps, w) {
  let curve = [];
  for (let i = 0; i < steps.length; i += 1) {
    curve.push([steps[i], fgompertz(steps[i], w, STEP_WEIGHT_POWER)]);
  }
  return curve;
}

export const xTickGenerator = function(axis) {
  var units = [
    {days: 360, singular: 'yr', plural: 'yrs', from: 84, to: 100000},
    {days: 30, singular: 'mth', plural: 'mths', from: 84, to: 100000},
    {days: 7, singular: 'w', plural: 'w', from: 0, to: 84}
  ];

  var wantedTicks = 8;
  var minTicks = 5;

  // Use fewer ticks on phones
  if ($(window).width() < 768) {
    wantedTicks = 4;
    minTicks = 3;
  }

  units = $.map(units, function(unit, i) {
    if (axis.max > unit.from && axis.max <= unit.to) {
      var step = Math.ceil(((axis.max - axis.min)/unit.days)/wantedTicks);
      var ticks = Math.ceil((axis.max - axis.min)/(step*unit.days));
      return $.extend(true, unit, {step: step, ticks: ticks});
    }
  });

  var res = [[0, 'birth']];

  for (let u = 0; u < units.length; u++) {
    var unit = units[u];
    var step = unit.step;
    var i = Math.floor(axis.min / unit.days);
    var v;
    do {
      v = i * unit.days;
      if (i !== 0) {
        var str = '';
        if (i === 1) {
          str = i + ' ' + unit.singular;
        } else {
          str = i + ' ' + unit.plural;
        }

        var useThis = true;
        for (let k = 0; k < res.length; k++) {
          if (res[k][0] > v - step*unit.days && res[k][0] < v + step*unit.days) {
            // Conflicting tick already exists, so drop this one
            useThis = false;
          }
        }
        if (useThis) res.push([v, str]);
      }
      i = i + step;
    } while (v < axis.max);
    if (unit.ticks >= minTicks) break;
  }
  return res;
}

export const b = function(w) {
  var bc = [[0.11927, 8.00545], [0.025506, 10.349538], [0.017578, 10.706303]];
  if (w < K[1]) {
    return bc[0][0]*w + bc[0][1];
  } else if (w < K[2]) {
    return bc[1][0]*w + bc[1][1];
  } else {
    return bc[2][0]*w + bc[2][1];
  }
}

export const d = function(w) {
  return 1-0.0014443*w;
}
